import { applicantHistoryRequests } from "@/src/api/applicantHistoryRequests";
import { tasksPageRequests } from "@/src/api/tasksPageRequests";
import { tasksStatusConst } from "@/src/constants/tasksConsts";

const REJECTED_STATUS = "rejected";

export interface ExecuteDocumentCheckRejectParams {
  taskId: string;
  applicantId?: number;
}

export type ExecuteDocumentCheckRejectResult =
  | { ok: true; message: string }
  | { ok: false; message: string };

/** Marks task as Rejected. Document and attached file are kept. */
export const executeDocumentCheckReject = async ({
  taskId,
  applicantId,
}: ExecuteDocumentCheckRejectParams): Promise<ExecuteDocumentCheckRejectResult> => {
  await tasksPageRequests.update(taskId, { status: REJECTED_STATUS });

  const rejectedLabel = tasksStatusConst.find((item) => item.id === REJECTED_STATUS)?.label ?? REJECTED_STATUS;

  if (applicantId != null && Number.isFinite(applicantId)) {
    try {
      await applicantHistoryRequests.create({
        applicant_id: applicantId,
        text: `Changes have been made to status updated to "${rejectedLabel}"`,
      });
    } catch (error) {
      console.warn("[DocumentCheckReject] History create failed:", error);
    }
  }

  return {
    ok: true,
    message: `Task marked as "${rejectedLabel}".`,
  };
};
